import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() { this.schedule() }
  disconnect() { window.clearTimeout(this.timer) }
  schedule() { this.timer = window.setTimeout(() => this.check(), 3000) }

  async check() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!this.element.isConnected) return
      if ([401, 403, 404].includes(response.status)) {
        this.element.textContent = "Диалог больше недоступен."
        return
      }
      if (!response.ok) throw new Error("Unavailable")
      const data = await response.json()
      if (this.connectionFailed && ["pending", "processing"].includes(data.status)) this.element.textContent = "Модель готовит ответ…"
      this.connectionFailed = false
      if (["pending", "processing"].includes(data.status)) return this.schedule()
      const output = document.createDocumentFragment()
      const text = data.status === "completed" ? data.answer : "Не удалось получить ответ. Возможно, компьютер с моделями выключен. Попробуйте позже."
      String(text).split(/```[^\n]*\n([\s\S]*?)```/).forEach((part, index) => {
        const node = document.createElement(index % 2 ? "pre" : "div")
        node.className = index % 2 ? "chat-code" : "ai-text"
        if (index % 2) node.textContent = part
        else {
          let offset = 0
          for (const match of part.matchAll(/\[([^\]\n]+)\]\((https?:\/\/[^\s<>"()]+)\)/g)) {
            node.append(document.createTextNode(part.slice(offset, match.index)))
            const link = document.createElement("a")
            link.textContent = match[1]
            link.href = match[2]
            link.target = "_blank"
            link.rel = "noopener noreferrer"
            link.dataset.turbo = "false"
            node.append(link)
            offset = match.index + match[0].length
          }
          node.append(document.createTextNode(part.slice(offset)))
        }
        output.append(node)
      })
      for (const url of data.images || []) {
        const link = document.createElement("a")
        link.href = url
        link.target = "_blank"
        link.rel = "noopener"
        const image = document.createElement("img")
        image.src = url
        image.alt = "Сгенерированное изображение"
        image.style.maxWidth = "100%"
        link.append(image)
        const download = document.createElement("a")
        const downloadURL = new URL(url, window.location.origin)
        downloadURL.searchParams.set("download", "1")
        download.href = downloadURL.href
        download.download = "generated.png"
        download.textContent = "Скачать PNG"
        download.className = "btn btn-sm btn-outline-primary d-block mt-2"
        download.dataset.turbo = "false"
        const picture = document.createElement("div")
        picture.className = "chat-generated-image"
        picture.append(link, download)
        output.append(picture)
      }
      this.element.replaceWith(output)
      document.querySelectorAll("#chat-form [disabled]").forEach((field) => { field.disabled = false })
      const send = document.querySelector("#chat-form [data-chat-target='send']")
      if (send?.dataset.connectionUnavailable === "true") send.disabled = true
      const input = document.querySelector("#ai_request_question")
      if (input) input.placeholder = "Сообщение…"
      document.dispatchEvent(new CustomEvent("chat:reply", { detail: { url: this.urlValue, status: data.status, answer: data.answer } }))
    } catch {
      if (this.element.isConnected) {
        this.connectionFailed = true
        this.element.textContent = "Нет соединения с сайтом. После восстановления связи ответ появится здесь; запрос повторно не отправляется."
        document.dispatchEvent(new CustomEvent("chat:connection-lost"))
        this.schedule()
      }
    }
  }
}
